<form [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" i18n>Create Channel Listing</h5>
    <button (click)="close()" type="button" class="close">
      <i class="far fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <p i18n>
          Create a listing on this channel from one of your AdvanceCM rentals. First, select the channel account in
          which you would like to create the new listing.
        </p>
        <app-select-search
          bindLabel="propertyId"
          [inline]="false"
          [items]="accounts$ | async"
          [ctrl]="form.get('account')"
          [multiple]="false"
          placeholder="Channel Account ID"
          i18n-placeholder
        >
          <ng-container class="error-container">
            <mat-error> <ng-container i18n>Value is required</ng-container> </mat-error>
          </ng-container>
        </app-select-search>
        <p i18n class="text-danger" *ngIf="isActiveAccount === false" style="margin-top: -15px">
          You can’t create a listing on the selected Airbnb account because it doesn’t have an active Airbnb listing. To
          create a listing it is mandatory that you already have an active listing on Airbnb.
        </p>

        <p>Now select the AdvanceCM rental you would like to publish.</p>
        <app-rental-select
          i18n-placeholder
          [ctrl]="form.get('rentalId')"
          [multiple]="false"
          placeholder="AdvanceCM Rental"
        >
        </app-rental-select>
        <p i18n class="text-danger" *ngIf="listingNameTooLong">
          Airbnb limits listing names to {{ listingNameMaxLength }} characters and this rental's display name is
          {{ listingName.length }} characters. Please shorten the rental's display name before creating the listing.
        </p>
        <div>
          <div>
            <app-form-switch [inline]="true" labelPosition="before" [formControl]="form.get('promotion')" i18n
              >Apply Promotion(20% Discount)</app-form-switch
            >
            <div class="text-xs text-muted" i18n>
              Discount will now expire after a listing earns its first 3 reviews, or reaches 10 bookings — whichever comes
              first.
            </div>
            <div class="text-xs text-muted" i18n>
              Discount will also apply only to eligible stay dates within 180 days of its creation.
            </div>
          </div>
          <div class="alert alert-secondary-warning2 align-items-start mt-3">
            <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
            <div class="alert-content text-xs">
              <div class="text-semi-bold text-dark" i18n>Eligibility Requirements:</div>
              <div class="text-muted" i18n>• Airbnb Smart Pricing is turned off</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="close()" type="button" class="btn btn-light">
      <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
    </button>
    <button
      (click)="onSave(form)"
      [disabled]="!isActiveAccount || form.invalid || isLoading || listingNameTooLong"
      type="button"
      class="btn btn-secondary-info create-btn"
    >
      <i class="far fa-plus" *ngIf="!isLoading"></i>
      <i class="far fa-spinner fa-spin" *ngIf="isLoading"></i>
      <ng-container i18n>Create</ng-container>
    </button>
  </div>
</form>
